import { render, staticRenderFns } from "./WhatBroughtYou.vue?vue&type=template&id=697fb8d4&scoped=true"
import script from "./WhatBroughtYou.vue?vue&type=script&lang=js"
export * from "./WhatBroughtYou.vue?vue&type=script&lang=js"
import style0 from "./WhatBroughtYou.vue?vue&type=style&index=0&id=697fb8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697fb8d4",
  null
  
)

export default component.exports